import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /jobs → redirect to /app/jobs (or /admin/jobs for staff,
// but the root gate handles that cross-role redirect automatically).
export const Route = createFileRoute("/jobs/")({
  beforeLoad: legacyRedirectTo("/app/jobs"),
  component: () => null,
});
